<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="用户名/手机"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number v-model="queryParam.callNo" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker v-model="queryParam.date" style="width: 100%" placeholder="请输入更新日期"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.useStatus" placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="name,record">
        <img :src="record.face" style="width: 40px; vertical-align: middle;" /> {{record.user_name}}
      </span>
      <span slot="action" slot-scope="text, record">
        <template >
          <a @click="handleLogManage(record)">明细管理</a>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
        </a-dropdown>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
            title="明细管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="logVisible"
            @ok="logVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="logColumns" :dataSource="logList" :pagination="logPagination"
                   @change="handleLogTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <template slot="footer" slot-scope="currentPageData">
              <div>
                <PriceInput  style="width: 200px; margin-right: 10px;" :formData="logFormData"
                             field="amount"
                             placeholder="调整余额"/>
                <a-input style="width: 200px; margin-right: 10px;" v-model="logFormData.note" placeholder="请输入理由" />
                <!--</a-select>-->
                <a-button icon="edit" @click="balanceEdit" >修改余额</a-button>
              </div>
              <div style="margin: 10px 0 0 0">
                <PriceInput  style="width: 200px; margin-right: 10px;" :formData="blockFormData"
                             field="amount"
                             placeholder="冻结余额"/>
                <a-input style="width: 200px; margin-right: 10px;" v-model="blockFormData.note" placeholder="请输入理由" />
                <!--</a-select>-->
                <a-button icon="edit" @click="blockedEdit" >冻结余额</a-button>
              </div>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import moment from 'moment'
  import UserPicker from '@/components/UserPicker/'
  import PriceInput from '@/components/PriceInput/'

  import { cashaccountList ,cashaccountLogList,balanceEdit,blockedEdit,withdrawlist,withdrawSuccess,withdrawError } from '@/api/cashaccount'

  export default {
    name: 'CashaccountList',
    components: {
      AInput,
      ATextarea,
      PriceInput,
      STable,
      UserPicker
    },
    data () {
      return {
        visible: false,
        logVisible: false,
        saveLoading:false,
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        groupOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            sorter: true
          },
          {
            title: '用户名',
            dataIndex: 'user_name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '手机号',
            dataIndex: 'phone'
          },
          {
            title: '可用余额',
            dataIndex: 'balance',
            sorter: true,
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '冻结余额',
            dataIndex: 'blocked_balance',
            sorter: true,
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '最后交易时间',
            dataIndex: 'update_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '200px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        logList:[],

        //管理表头
        logColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '交易金额',
            width:'150px',
            dataIndex: 'amount',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '余额',
            width:'150px',
            dataIndex: 'balance',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '类型',
            dataIndex: 'title',
            width:'100px',
          },
          {
            title: '附加信息',
            dataIndex: 'extra_note',
            width:'200px',
          },
          {
            title: '时间',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
        ],
        logPagination:{
            current: 1,
            pageSize:10,
            showTotal: (total) =>{
              return '总计'+total+'条'
            }
        },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam = Object.assign( this.queryParam ,parameter);
          return cashaccountList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
        logQuery:{
          account_id:0,
          pageSize:10,
          pageNo:1
        },
        logFormData:{
          account_id:undefined,
          amount:undefined,
          note:undefined
        },
        blockFormData:{
          account_id:undefined,
          amount:undefined,
          note:undefined
        },
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    mounted(){
    },
    methods: {


      handleLogManage(record) {
        let self = this
        self.logQuery.account_id = record.id;
        self.logFormData.account_id = record.id;
        self.blockFormData.account_id = record.id;
        self.logPagination.current = 1;
        self.fetchLogList();
        this.logVisible = true
      },
      fetchLogList(){
        let self = this
        cashaccountLogList(self.logQuery).then(res => {
          self.logList = res.data.list

//          const pagination = { ...self.logPagination };
          // Read total count from server
//           pagination.total = res.data.total;
          self.$set(self.logPagination,'total',res.data.total);
//          self.logPagination.total = res.data.total;
//          pagination.total = 200;
//          self.logPagination = pagination;
        })
      },
      handleLogTableChange(pagination, filters, sorter){
        let that = this;
        that.logQuery.pageNo = pagination.current;
        that.$set(that.logPagination,'current',pagination.current);
        that.fetchLogList();
      },
      balanceEdit(){
        let that = this;
        balanceEdit(that.logFormData).then(res => {
          that.$message.success('修改成功')
          that.fetchLogList();
          that.$refs.table.refresh()
          that.logVisible = false;
          that.logFormData = {
            account_id:undefined,
                    amount:undefined,
                    note:undefined
          };
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
      },
      blockedEdit(){
        let that = this;
        blockedEdit(that.blockFormData).then(res => {
          that.$message.success('修改成功')
          that.fetchLogList();
          that.$refs.table.refresh()
          that.logVisible = false;
          that.blockFormData = {
            account_id:undefined,
            amount:undefined,
            note:undefined
          };
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
      },

      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      resetSearchForm () {
        this.queryParam = {
          date: moment(new Date())
        }
      }
    },
    watch: {
      /*
       'selectedRows': function (selectedRows) {
       this.needTotalList = this.needTotalList.map(item => {
       return {
       ...item,
       total: selectedRows.reduce( (sum, val) => {
       return sum + val[item.dataIndex]
       }, 0)
       }
       })
       }
       */
    }
  }
</script>

<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
